var exports = {
  "Nr": "CrosspostCommunityCard.module__card___NTdkVX",
  "Uo": "CrosspostCommunityCard.module__sheetCard___NTdkVX",
  "vK": "CrosspostCommunityCard.module__banner___NTdkVX",
  "_e": "CrosspostCommunityCard.module__bannerImage___NTdkVX",
  "Dw": "CrosspostCommunityCard.module__bannerScrim___NTdkVX",
  "Kk": "CrosspostCommunityCard.module__icon___NTdkVX",
  "rf": "CrosspostCommunityCard.module__body___NTdkVX",
  "$": "CrosspostCommunityCard.module__titleRow___NTdkVX",
  "fh": "CrosspostCommunityCard.module__nameText___NTdkVX",
  "h_": "CrosspostCommunityCard.module__description___NTdkVX",
  "qr": "CrosspostCommunityCard.module__footer___NTdkVX",
  "dJ": "CrosspostCommunityCard.module__stat___NTdkVX",
  "rR": "CrosspostCommunityCard.module__statDotOnline___NTdkVX" + " " + "CrosspostCommunityCard.module__statDot___NTdkVX",
  "rb": "CrosspostCommunityCard.module__statDotMembers___NTdkVX" + " " + "CrosspostCommunityCard.module__statDot___NTdkVX",
  "KA": "CrosspostCommunityCard.module__statText___NTdkVX",
  "lm": "CrosspostCommunityCard.module__notice___NTdkVX",
  "XI": "CrosspostCommunityCard.module__action___NTdkVX",
  "Lq": "CrosspostCommunityCard.module__loading___NTdkVX",
};

module.exports = exports;
